import { ApiService } from '../../../../services/api.service';
import _ from 'lodash';

/**
 * @function getRoleSetState - Function to get the logged in (or aliased) user's role and set the auth state
 * @param name - The user's username
 * @param roleId - Role Id of the logged in (or aliased) user
 * @param userID - User Id of the logged in (or aliased) user
 * @param empID - Employeed Id of the logged in (or aliased) user
 * @param setState - hook to set the Auth context state
 * @param logout - function to logout user
 * @param accessToken - hallenToken, required for any API request
 * @param removeCookie - remove the cookie
 */
export const getRoleSetState = async (name, roleId, userID, empID, setState, logout, accessToken?: string, removeCookie?, isAdUser?) => {
  const accessParam = new URLSearchParams({
    roleId: roleId,
  });
  ApiService.get(process.env.ROLE_ACCESS, accessParam).then((accessRes: any) => {
    if (accessRes.status === 200) {
      let tempRules = [];
      accessRes.data.data.forEach(perm => {
        if (perm.moduleItemName === 'Base Module') {
          perm.permissionList.forEach(listItem => {
            tempRules.push(`${_.camelCase(perm.moduleName)}:${listItem}`);
            if (
              // `${_.camelCase(perm.moduleName)}:${listItem}` ===
              //   "employee:read" ||
              // `${_.camelCase(perm.moduleName)}:${listItem}` ===
              //   "engineer:read" ||
              // `${_.camelCase(perm.moduleName)}:${listItem}` ===
              //   "employeeGroups:read" ||
              // `${_.camelCase(perm.moduleName)}:${listItem}` ===
              //   "digSafe:read" ||
              `${_.camelCase(perm.moduleName)}:${listItem}` === 'user:create' ||
              (`${_.camelCase(perm.moduleName)}:${listItem}` === 'roles:create' && !tempRules.includes('maintenance:read'))
            ) {
              tempRules.push('maintenance:read');
            }
          });
        } else {
          perm.permissionList.forEach(listItem => {
            tempRules.push(`${_.camelCase(perm.moduleName + perm.moduleItemName)}:${listItem}`);
          });
        }
      });
      const userParams = new URLSearchParams({ userId: 'me' });
      ApiService.get(process.env.USER_DETAIL, userParams).then((res: any) => {
        setState(prevState => ({
          ...prevState,
          authenticated: true,
          user: {
            username: name,
            userId: userID,
            roleId: roleId,
            avatar: res.status === 200 ? res.data.data.avatar : '',
          },
          isAdUser: isAdUser ? isAdUser : false,
          rules: [
            ...tempRules,
            // may add here rbac strings for development purposes
            // if not provided yet by the backend, e.g.:
            //"equipments:read",
          ],
          loading: false,
        }));
      });
    } else {
      logout(removeCookie, setState);
    }
  });
};
